import React from 'react';

import PropTypes from 'prop-types';

import { LAYOUT_TYPE } from '../../../constants';

import FilterOptionsDefaultBtn from './FilterOptionsDefaultBtn';
import FilterOptionsDefaultCheckbox from './FilterOptionsDefaultCheckbox';

const FilterOptionsCustomBra = ({
  layoutType = LAYOUT_TYPE.FILTER_PANEL,
  ...rest
}) => {
  // TODO: implement custom bra filter option
  // https://techstyle-prod.atlassian.net/browse/FLCE-3050

  return layoutType === LAYOUT_TYPE.FILTER_PANEL ? (
    <FilterOptionsDefaultCheckbox {...rest} />
  ) : (
    <FilterOptionsDefaultBtn {...rest} />
  );
};

FilterOptionsCustomBra.propTypes = {
  layoutType: PropTypes.oneOf(Object.values(LAYOUT_TYPE)),
};

export default FilterOptionsCustomBra;
